import SalariePseudo from '@/generated/controls/salarie/SalariePseudo.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: SalariePseudo
})
